import React from 'react';
import { PROJECTS } from '../data/sectionsData';
import ShowMoreButton from './ShowMoreButton';

const INITIAL_VISIBLE_PROJECTS = 3;

export default function ProjectsSection({ expanded, onToggle, getVisibleItems }) {
    return (
        <section className="py-16 md:py-24 px-4 md:px-6 max-w-[1200px] mx-auto" id="projects">
            <div className="mb-16 reveal">
                <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-container text-on-primary-container rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                    <i className="fa-solid fa-code"></i> Projects
                </span>
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-on-surface mb-2">Things I've Built</h2>
                <p className="text-[1.0625rem] text-on-surface-variant max-w-[560px] leading-relaxed">
                    A few highlighted projects from my portfolio. I enjoy working across the full stack and love experimenting with new tech.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {getVisibleItems('projects', PROJECTS).map((p, i) => (
                    <div key={i} className={`bg-surface-container rounded-2xl overflow-hidden shadow-1 hover:-translate-y-1 hover:shadow-3 transition-all duration-400 ease-emphasized reveal reveal-delay-${Math.min(i + 1, 4)}`}>
                        {/* Image */}
                        <div className="w-full h-[200px]">
                            <div className={`${p.gradient} w-full h-full flex items-center justify-center text-5xl text-white/80`}>
                                <i className={p.icon}></i>
                            </div>
                        </div>
                        {/* Body */}
                        <div className="p-6">
                            <h3 className="text-xl font-bold text-on-surface mb-2">{p.title}</h3>
                            <p className="text-[0.9375rem] text-on-surface-variant leading-relaxed mb-4">{p.desc}</p>
                            <div className="flex flex-wrap gap-2 mb-4">
                                {p.tags.map((t) => (
                                    <span key={t} className="px-3 py-1 bg-surface-variant rounded-full text-xs font-medium text-on-surface-variant">{t}</span>
                                ))}
                            </div>
                            <div className="flex gap-4">
                                <a href={p.github} className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-tertiary transition-colors duration-200" target="_blank" rel="noopener noreferrer">
                                    <i className="fa-brands fa-github"></i> Code
                                </a>
                                {p.live && <a href={p.live} className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-tertiary transition-colors duration-200" target="_blank" rel="noopener noreferrer">
                                    <i className="fa-solid fa-arrow-up-right-from-square"></i> Live
                                </a>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <ShowMoreButton
                expanded={expanded}
                onClick={onToggle}
                totalCount={PROJECTS.length}
                visibleCount={INITIAL_VISIBLE_PROJECTS}
            />
        </section>
    );
}
